import { render, staticRenderFns } from "./no-content.vue?vue&type=template&id=49003da2&scoped=true&"
import script from "./no-content.vue?vue&type=script&lang=js&"
export * from "./no-content.vue?vue&type=script&lang=js&"
import style0 from "./no-content.scss?vue&type=style&index=0&id=49003da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49003da2",
  null
  
)

export default component.exports